import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { Categoria } from '../models/categoria';
import { Prodotto } from '../models/prodotto';
import { Produttore } from '../models/produttore';
import { catchError, map, throwError } from 'rxjs';
import { Indirizzo } from '../models/indirizzo';
import { CartItem } from '../models/cart-item';
import { Articolo } from '../models/articolo';
import { User } from '../models/user';
import { MediaObject } from '../models/media-object';
import { ProdottoImmagine, ProdottoImmagineToPost } from '../models/prodotto-immagine';
import Utility from '../helpers/utility';
import { Cliente } from '../models/cliente';
import { Ordine } from '../models/ordine';


const API = GlobalComponent.API_URL;

@Injectable({
  providedIn: 'root'
})
export class CinetykApiService {

  constructor(private http: HttpClient) { }

  // #region Categorie
  public getCategorieAll(){
    return this.http.get<string[]>(`${API}categorias`);
  }

  getCategoriaById(id: number)
  {
    return this.http.get<Categoria>(`${API}categorias/${id}`).pipe(map((rsp:any)=>({
      id: rsp.id,
      nome: rsp.nome,
      descrizione: rsp.descrizione,
      tipologia: rsp.tipologia,
      prodotti: rsp.prodottos
    })));
  }

  postCategoria(t:Categoria){
    return this.http.post<Categoria>(`${API}categorias`, t).pipe(map((rsp:any)=>({
      id: rsp.id,
      nome: rsp.nome,
      descrizione: rsp.descrizione,
      tipologia: rsp.tipologia
    })));
  }

  putCategoria(t:Categoria){
    return this.http.put<Categoria>(`${API}categorias/${t.id}`, t).pipe(map((rsp:any)=>({
      id: rsp.id,
      nome: rsp.nome,
      descrizione: rsp.descrizione,
      tipologia: rsp.tipologia
    })));
  }

  deleteCategoria(t:Categoria){
    return this.http.delete<Categoria>(`${API}categorias/${t.id}`);
  }
  // #endregion

  // #region Prodotti
  public getProdottiAll(){
    return this.http.get<string[]>(`${API}prodottos`);
  }

  getProdottoById(id: number)
  {
    return this.http.get<Prodotto>(`${API}prodottos/${id}`).pipe(map((rsp:any)=>({
      id: rsp.id,
      nome: rsp.nome,
      description: rsp.description,
      sku: rsp.sku,
      altezza: rsp.altezza,
      larghezza: rsp.larghezza,
      peso: rsp.peso,
      magazzino: rsp.magazzino,
      produttore: rsp.produttore,
      prezzo: rsp.prezzo,
      categoria: rsp.categoria,
      pubblicato : rsp.pubblicato,
      immagini: rsp.immagini,
      tempoProduzione: rsp.tempo_produzione,
      evidenza: rsp.evidenza,
      limitata: rsp.limitata,
      varianti: rsp.varianti
    })));
  }

  postProdotto(t:Prodotto){
    return this.http.post<Prodotto>(`${API}prodottos`, t).pipe(map((rsp:any)=>({
      id: rsp.id,
      nome: rsp.nome,
      description: rsp.description,
      sku: rsp.sku,
      altezza: rsp.altezza,
      larghezza: rsp.larghezza,
      peso: rsp.peso,
      magazzino: rsp.magazzino,
      produttore: rsp.produttore,
      prezzo: rsp.prezzo,
      categoria: rsp.categoria,
      pubblicato : rsp.pubblicato,
      immagini: rsp.immagini,
      tempoProduzione: rsp.tempo_produzione,
      evidenza: rsp.evidenza,
      limitata: rsp.limitata,
      varianti: rsp.varianti
    })));
  }

  putProdotto(t:Prodotto){
    return this.http.put<Prodotto>(`${API}prodottos/${t.id}`, t).pipe(map((rsp:any)=>({
      id: rsp.id,
      nome: rsp.nome,
      description: rsp.description,
      sku: rsp.sku,
      altezza: rsp.altezza,
      larghezza: rsp.larghezza,
      peso: rsp.peso,
      magazzino: rsp.magazzino,
      produttore: rsp.produttore,
      prezzo: rsp.prezzo,
      categoria: rsp.categoria,
      pubblicato : rsp.pubblicato,
      immagini: rsp.immagini,
      tempoProduzione: rsp.tempo_produzione,
      evidenza: rsp.evidenza,
      limitata: rsp.limitata,
      varianti: rsp.varianti
    })));
  }

  deleteProdotto(t:Prodotto){
    return this.http.delete<Prodotto>(`${API}prodottos/${t.id}`);
  }

  // #endregion

  // #region Produttori

  public getProduttoriAll(){
    return this.http.get<string[]>(`${API}produttores`);
  }

  getProduttoreById(id: number)
  {
    return this.http.get<Produttore>(`${API}produttores/${id}`).pipe(map((rsp:any)=>({
      id: rsp.id,
      nome: rsp.nome,
      indirizzo: rsp.indirizzo,
      descrizione: rsp.descrizione
    })));
  }

  postProduttore(t:Produttore){
    return this.http.post<Produttore>(`${API}produttores`, t).pipe(map((rsp:any)=>({
      id: rsp.id,
      nome: rsp.nome,
      indirizzo: rsp.indirizzo,
      descrizione: rsp.descrizione
    })));
  }

  putProduttore(t:Produttore){
    return this.http.put<Produttore>(`${API}produttores/${t.id}`, t).pipe(map((rsp:any)=>({
      id: rsp.id,
      nome: rsp.nome,
      indirizzo: rsp.indirizzo,
      descrizione: rsp.descrizione
    })));

    
  }

  deleteProduttore(t:Produttore){
    return this.http.delete<Produttore>(`${API}produttores/${t.id}`);
  }

  // #endregion

  // #region Indirizzi

    public getIndirizziAll(){
      return this.http.get<string[]>(`${API}indirizzos`);
    }
  
    getIndirizzoById(id: number)
    {
      return this.http.get<Indirizzo>(`${API}indirizzos/${id}`).pipe(map((rsp:any)=>({
        id: rsp.id,
        via: rsp.via,
        civico: rsp.civico,
        cap: rsp.cap,
        citta: rsp.citta,
        provincia: rsp.provincia,
        stato: rsp.stato,
        tipologia: rsp.tipologia,
        produttore: rsp.produttore,
        cO: rsp.cO
      })));
    }
  
    postIndirizzo(t:Indirizzo){
      return this.http.post<Indirizzo>(`${API}indirizzos`, t).pipe(map((rsp:any)=>({
        id: rsp.id,
        via: rsp.via,
        civico: rsp.civico,
        cap: rsp.cap,
        citta: rsp.citta,
        provincia: rsp.provincia,
        stato: rsp.stato,
        tipologia: rsp.tipologia,
        produttore: rsp.produttore,
        cO: rsp.cO
      })));
    }
  
    putIndirizzo(t:Indirizzo){
      return this.http.put<Indirizzo>(`${API}indirizzos/${t.id}`, t).pipe(map((rsp:any)=>({
        id: rsp.id,
        via: rsp.via,
        civico: rsp.civico,
        cap: rsp.cap,
        citta: rsp.citta,
        provincia: rsp.provincia,
        stato: rsp.stato,
        tipologia: rsp.tipologia,
        produttore: rsp.produttore,
        cO: rsp.cO
      })));
    }

    deleteIndirizzo(t:Indirizzo){
      return this.http.delete<Indirizzo>(`${API}indirizzos/${t.id}`);
    }
    // #endregion

 // #region Carrello
 postCarrello(t:CartItem){
  return this.http.post<CartItem>(`${API}carrellos`, t);
}
 /*public getIndirizziAll(){
  return this.http.get<string[]>(`${API}indirizzos`);
}

getIndirizzoById(id: number)
{
  return this.http.get<Indirizzo>(`${API}indirizzos/${id}`).pipe(map((rsp:any)=>({
    id: rsp.id,
    via: rsp.via,
    civico: rsp.civico,
    cap: rsp.cap,
    citta: rsp.citta,
    provincia: rsp.provincia,
    stato: rsp.stato,
    tipologia: rsp.tipologia,
    produttore: rsp.produttore,
    cO: rsp.cO
  })));
}

postIndirizzo(t:Indirizzo){
  return this.http.post<Indirizzo>(`${API}indirizzos`, t).pipe(map((rsp:any)=>({
    id: rsp.id,
    via: rsp.via,
    civico: rsp.civico,
    cap: rsp.cap,
    citta: rsp.citta,
    provincia: rsp.provincia,
    stato: rsp.stato,
    tipologia: rsp.tipologia,
    produttore: rsp.produttore,
    cO: rsp.cO
  })));
}

putIndirizzo(t:Indirizzo){
  return this.http.put<Indirizzo>(`${API}indirizzos/${t.id}`, t).pipe(map((rsp:any)=>({
    id: rsp.id,
    via: rsp.via,
    civico: rsp.civico,
    cap: rsp.cap,
    citta: rsp.citta,
    provincia: rsp.provincia,
    stato: rsp.stato,
    tipologia: rsp.tipologia,
    produttore: rsp.produttore,
    cO: rsp.cO
  })));
}

deleteIndirizzo(t:Indirizzo){
  return this.http.delete<Indirizzo>(`${API}indirizzos/${t.id}`);
}

*/
// #endregion


// #region Articolo
public getArticoliAll(){
  return this.http.get<string[]>(`${API}articolos`);
}

getArticoloById(id: number)
{
  return this.http.get<Articolo>(`${API}articolos/${id}`).pipe(map((rsp:Articolo)=>({
    id: rsp.id,
    titolo: rsp.titolo,
    testo: rsp.testo,
    createdBy: rsp.createdBy,
    pubblicato: rsp.pubblicato,
    data: rsp.data,
    image: rsp.image,
    blog: rsp.blog
  })));
}

postArticolo(t:Articolo){
  return this.http.post<Articolo>(`${API}articolos`, t).pipe(map((rsp:Articolo)=>({
    id: rsp.id,
    titolo: rsp.titolo,
    testo: rsp.testo,
    createdBy: rsp.createdBy,
    pubblicato: rsp.pubblicato,
    data: rsp.data,
    image: rsp.image,
    blog: rsp.blog
  })));
}

putArticolo(t:Articolo){
  return this.http.put<Articolo>(`${API}articolos/${t.id}`, t).pipe(map((rsp:Articolo)=>({
    id: rsp.id,
    titolo: rsp.titolo,
    testo: rsp.testo,
    createdBy: rsp.createdBy,
    pubblicato: rsp.pubblicato,
    data: rsp.data,
    image: rsp.image,
    blog: rsp.blog
  })));

  
}

deleteArticolo(t:Articolo){
  return this.http.delete<Articolo>(`${API}articolos/${t.id}`);
}

// #endregion

// #region Image

getImageById(id: number)
  {
    return this.http.get<MediaObject>(`${API}media_objects/${id}`).pipe(map((rsp:any)=>({
      "@id": rsp['@id'],
      '@type': rsp['@type'],
      filePath: rsp.filePath,
      prodotto: rsp.prodotto
    })));
  }


 uploadImage(formUploadData: FormData){
  return this.http.post(`${API}media_objects`, formUploadData).pipe(map((rsp:any)=>({
    "@id": rsp['@id'],
    '@type': rsp['@type'],
    filePath: rsp.filePath,
    prodotto: rsp.prodotto
  })));
 }

 putImage(t: MediaObject){
  return this.http.put<MediaObject>(`${API}media_objects/${Utility.ClearId(t['@id'])}`, t).pipe(map((rsp:MediaObject)=>({
    "@id": rsp['@id'],
    '@type': rsp['@type'],
    filePath: rsp.filePath,
    prodotto: rsp.prodotto
  })));

 }

 deleteImage(t: MediaObject){
  return this.http.delete<MediaObject>(`${API}media_objects/${Utility.ClearId(t['@id'])}`);
 }

 // #endregion

// #region ProdottoImmagine

postProdottoImmagine(t:ProdottoImmagineToPost){
  return this.http.post<ProdottoImmagineToPost>(`${API}prodotto_immagines`, t).pipe(map((rsp:ProdottoImmagineToPost)=>({
    id: rsp.id,
    immagine: rsp.immagine,
    principale: rsp.principale,
    prodotto: rsp.prodotto
  })));
}

putProdottoImmagine(t:ProdottoImmagineToPost){
  return this.http.put<ProdottoImmagineToPost>(`${API}prodotto_immagines/${Utility.ClearId(t['id'])}`, t).pipe(map((rsp:ProdottoImmagineToPost)=>({
    id: rsp.id,
    immagine: rsp.immagine,
    principale: rsp.principale,
    prodotto: rsp.prodotto
  })));
}

deleteProdottoImmagine(t: ProdottoImmagine){
  return this.http.delete<ProdottoImmagine>(`${API}prodotto_immagines/${Utility.ClearId(t['@id'])}`);
 }

// #endregion

// #region user
public getUserAll(){
  return this.http.get<string[]>(`${API}users`).pipe(catchError(this.handleError));
}

postUser(t:User){
  return this.http.post<User>(`${API}users`, t).pipe(
    map((rsp:User)=>({
      username: rsp.username,
      email: rsp.email,
      "@id": rsp['@id'],
      cliente: rsp.cliente
    })),
    catchError(this.handleError)
);
}

// #endregion

// #region Cliente
postCliente(t:Cliente){
  return this.http.post<Cliente>(`${API}clientes`, t).pipe(
    map((rsp:Cliente)=>({
      nome: rsp.nome,
      cognome: rsp.cognome,
      dataNasciata: rsp.dataNascita,
      luogoNascita: rsp.luogoNascita,
      codiceFiscale: rsp.codiceFiscale,
      nazionalita: rsp.nazionalita,
      piva: rsp.piva,
      cap: rsp.cap,
      citta: rsp.citta,
      via: rsp.via,
      civico: rsp.civico
    })),
    catchError(this.handleError)
);
}
// #endregion

// #region Ordini
public getOrdiniAll(){
  return this.http.get<string[]>(`${API}ordinis`);
}

getOrdineById(id: number)
{
  return this.http.get<Ordine>(`${API}ordinis/${id}`).pipe(map((rsp:any)=>({
    cliente: rsp.cliente,
    stato: rsp.stato,
    note: rsp.note,
    transazione: rsp.transazione,
    tipologiaPagamento: rsp.tipologiaPagamento
  })));
}

postOrdine(t:Ordine){
  return this.http.post<Ordine>(`${API}ordinis`, t).pipe(map((rsp:any)=>({
    cliente: rsp.cliente,
    stato: rsp.stato,
    note: rsp.note,
    transazione: rsp.transazione,
    tipologiaPagamento: rsp.tipologiaPagamento
  })));
}

putOrdine(t:Ordine){
  return this.http.put<Ordine>(`${API}ordinis/${t.id}`, t).pipe(map((rsp:any)=>({
    id: rsp.id,
    nome: rsp.nome,
    descrizione: rsp.descrizione,
    tipologia: rsp.tipologia
  })));
}

deleteOrdine(t:Ordine){
  return this.http.delete<Ordine>(`${API}ordinis/${t.id}`);
}
// #endregion

private handleError(error: HttpErrorResponse) {
  if (error.status === 0) {
    // A client-side or network error occurred. Handle it accordingly.
    console.error('An error occurred:', error.error);
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong.
    console.error(
      `Backend returned code ${error.status}, body was: `, error.error);

  }
  // Return an observable with a user-facing error message.
  return throwError(() => error);
}
}
